import React, { useState, useEffect } from 'react';
import DynamicBanner from '../../include/DynamicBanner';
import './FacultyAwards.css';
import api from '../../../../api';

const FacultyAwards = () => {
  const [awardsData, setAwardsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedTables, setExpandedTables] = useState({});

  useEffect(() => {
    const fetchAwardsData = async () => {
      try {
        const response = await api.get("/api/sitepages/academic/faculty_awards");
        const data = response.data;

        const rawImages = data?.banner_data?.images || [];
        const formattedImages = rawImages.map(img =>
          img && !img.startsWith("/") ? `/${img}` : img
        );

        data.banner_data.images = formattedImages;

        setAwardsData(data);
        setIsLoading(false);

      } catch (err) {
        console.error("Error fetching Faculty Awards data:", err);
        setError("Failed to load Faculty Awards data");
        setIsLoading(false);
      }
    };

    fetchAwardsData();
  }, []);

  const toggleTableRows = (index) => {
    setExpandedTables(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error || !awardsData) {
    return <div>{error}</div>;
  }


  const bannerData = awardsData.banner_data || {};
  const sections = awardsData.sections || [];

  const bannerTitle = bannerData.title || "";
  const bannerImages = bannerData.images || [];
    const mobileimage=bannerData.mobile_images ||[];

  const getVisibleRows = (rows, isExpanded) => {
    if (isExpanded || rows.length <= 10) {
      return rows;
    }
    return rows.slice(0, 10);
  };

  return (
    <>

      {bannerImages.length > 0 && (
        <DynamicBanner
          title={bannerTitle}
          bgImage={bannerImages}
             bgImageMobile={mobileimage}
        />
      )}

      <section className='faculty-awards-section'>
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">

            {sections.map((section, sectionIndex) => {
              const isExpanded = expandedTables[sectionIndex];
              const visibleRows = getVisibleRows(section.rows || [], isExpanded);
              const hasMoreRows = (section.rows || []).length > 10;

              return (
                <div key={sectionIndex} className="mb-5">

                  <div className="sec-title text-center">
                    <h2>{section.title}</h2>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-bordered table-hover awards-table">
                      <thead>
                        <tr>
                          {section.columns && section.columns.map((column, colIndex) => (
                            <th key={colIndex}>{column}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {visibleRows.map((row, rowIndex) => (
                          <tr 
                            key={rowIndex}
                            className={rowIndex >= 10 ? "hidden-rows" : ""}
                            style={{ 
                              display: rowIndex >= 10 && !isExpanded ? 'none' : 'table-row' 
                            }}
                          >
                            {row.map((cell, cellIndex) => (
                              <td key={cellIndex}>{cell || '-'}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>

                  

                    {section.read_more_link && (
                      <div className="text-center mt-3">
                        <a 
                          href={section.read_more_link} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="read-more-btn-faculty d-inline-block mx-auto"
                        >
                          {section.read_more_text || 'Learn More'}
                        </a>
                      </div>
                    )}
                  </div>
                    {hasMoreRows && (
                      <div>
                        <button
                          className="read-more-btn-faculty d-inline-block mx-auto"
                          onClick={() => toggleTableRows(sectionIndex)}
                        >
                          {isExpanded 
                            ? (section.read_more_text || 'Read Less') 
                            : (section.read_more_text || 'Read More')
                          }
                        </button>
                      </div>
                    )}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default FacultyAwards;